"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
String.isNullOrWhitespace = function (str) {
    if (str == undefined) {
        //console.log("string undefinied")
        return true;
    }
    if (str == null) {
        //console.log("string null");
        return true;
    }
    if (str.length === 0) {
        //console.log("string length is 0");
        return true;
    }
    if (str.match(/^ *$/) !== null) {
        //console.log("string is whitepsace (regex)");
        return true;
    }
    if (!str.trim()) {
        //console.log("string trim");
        return true;
    }
    return (str == undefined || str == null || str.length === 0 || str.match(/^ *$/) !== null || !str.trim());
};
Array.isNullOrEmpty = function (array) {
    return (array == undefined || array == null || array.length === 0);
};
//# sourceMappingURL=Extensions.js.map